import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import type { DeprecatedVault } from '@/config/deprecated-vaults';
import { type DeprecatedVaultPromptVariant, trackDeprecatedVaultPromptViewed } from '../trackers/deprecated-vault';

/**
 * Fires one impression per vault whose withdrawal prompt is on screen. An Effect
 * rather than render, same reasoning as `useTrackV1ToV2MigrationEntryViewed`: the
 * only signal is the toast being committed, and these components run under the
 * React Compiler. The ref set keeps it to one fire per vault and variant per
 * mount, StrictMode's double-invoke included.
 */
export const useTrackDeprecatedVaultPromptViewed = (vaults, variant) => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Set();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const tracked = useRef(t0);
  let t1;
  let t2;
  if ($[1] !== variant || $[2] !== vaults) {
    t1 = () => {
      for (const vault of vaults) {
        const key = `${vault.address}:${variant}`;
        if (tracked.current.has(key)) {
          continue;
        }
        tracked.current.add(key);
        trackDeprecatedVaultPromptViewed({
          chainId: vault.chainId,
          vaultAddress: vault.address,
          variant
        });
      }
    };
    t2 = [vaults, variant];
    $[1] = variant;
    $[2] = vaults;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
};